var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/social/tumblr.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<svg width=\"616px\" height=\"1000px\" viewBox=\"0 0 616 1000\" class=\"c-social__tumblr\" aria-labelledby=\"tumblr-svg-title\" xmlns=\"http://www.w3.org/2000/svg\">\n    <title id=\"tumblr-svg-title\">\n        ";
output += runtime.suppressValue((lineno = 2, colno = 10, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["social-tumblr"])), env.opts.autoescape);
output += "\n    </title>\n    <path d=\"M0 410l0-142q60-20 101-55 41-33 67-86 26-51 35-127l143 0l0 253l237 0l0 157l-237 0l0 256q0 86 9 112 9 24 34 39 34 20 76 20 77 0 151-49l0 157q-63 31-116 43-52 12-112 12-68 0-122-17-55-19-89-50-36-31-52-68-14-34-14-105l0-350l-111 0z\"></path>\n</svg>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/social/tumblr.j2"] , dependencies)